// extracted by mini-css-extract-plugin
export default {"keyboard":"PlacementVirtualKeyboard_keyboard__imxon","keyboard__landscape":"PlacementVirtualKeyboard_keyboard__landscape__KYo4V"};